import { useState, useCallback } from 'react';

/**
 * Custom hook for managing audio player state.
 *
 * @returns {Object} Audio player state and control functions
 */
const useAudioPlayer = () => {
  const [audioPlayerState, setAudioPlayerState] = useState({
    isOpen: false,
    audioSrc: '',
    title: '',
    messageId: null
  });

  // Open the audio player
  const openAudioPlayer = useCallback((audioSrc, title = 'Audio Player', messageId = null) => {
    setAudioPlayerState({
      isOpen: true,
      audioSrc,
      title,
      messageId
    });
  }, []);

  // Close the audio player
  const closeAudioPlayer = useCallback(() => {
    // Completely reset the audio player state
    setAudioPlayerState({
      isOpen: false,
      audioSrc: '',
      title: '',
      messageId: null
    });
  }, []);

  return {
    audioPlayerState,
    openAudioPlayer,
    closeAudioPlayer
  };
};

export default useAudioPlayer;